export const ADD_API_MESSAGE = "MESSAGE_BAR/ADD_API_MESSAGE";
export const REMOVE_ITEM = "MESSAGE_BAR/REMOVE_ITEM";
